export class ActionResponsePayload<T> {
	constructor(public data: T) {}
}
